// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-64a7c7b8]{font-size:2em}section[data-v-64a7c7b8]{padding-top:60px;padding-bottom:60px}.content[data-v-64a7c7b8]  h1{line-height:normal;margin-bottom:30px}.content[data-v-64a7c7b8]  h2{line-height:normal;margin-top:40px;margin-bottom:20px}.content[data-v-64a7c7b8]  h3{line-height:normal;margin-top:20px;margin-bottom:10px}.content[data-v-64a7c7b8]  p,.content[data-v-64a7c7b8]  ul{margin-top:10px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
